import { combineSlices } from "@reduxjs/toolkit";
import detailSlice from "slices/contracts/detail/detailSlice";

import contractsHomeSlice from "./home/contractsHomeSlice";

const combined = combineSlices(contractsHomeSlice, detailSlice);

export default combined;
